import AssignmentDetail from './components/assignments';
import CompletionDetail from './components/completions';
import DctList from './components/dct-list';
import ConversationDetail from './components/detail';

const SelectedComponent = ({
  selectedScreen,
  conversation,
  getConversationDetails,
  isEvaluation,
  version,
  evaluationId,
}) => {
  switch (selectedScreen) {
    case 'assignments':
      return (
        <AssignmentDetail
          conversation={conversation}
          isEvaluation={isEvaluation}
          version={version}
          evaluationId={evaluationId}
        />
      );
    case 'responses-completion':
      return <CompletionDetail />;
    case 'dct':
      return <DctList />;
    default:
      return (
        <ConversationDetail
          conversation={conversation}
          getConversationDetails={getConversationDetails}
          isEvaluation={isEvaluation}
        />
      );
  }
};

export default SelectedComponent;
